import { useEffect, useState } from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import StorySection from "@/components/StorySection";
import CollectionSection from "@/components/CollectionSection";
import ClientLogosSection from "@/components/ClientLogosSection";
import PartnershipSection from "@/components/PartnershipSection";
import Footer from "@/components/Footer";

function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App" data-testid="app-container">
      <Navigation scrolled={scrolled} />
      <main>
        <HeroSection />
        <StorySection />
        <CollectionSection />
        <ClientLogosSection />
        <PartnershipSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
